import React, { useEffect, useCallback, useState} from 'react';
import EffectParameterSlider from './EffectParameterSlider.js';
import {connect} from 'react-redux';

const TransientShaperComponent = ({effect, sequencerEngine}) => { 
    return (
        <div>
       <EffectParameterSlider
            name='Attack'
            parameter={effect.attackParameter}
            isParameter={true}
            step={0.01}
            max={4}
            min={-4}
          />
        <EffectParameterSlider
            name='Sustain'
            parameter={effect.sustainParameter}
            isParameter={true}
            step={0.01}
            max={0.5}
            min={0}
          />
        <EffectParameterSlider
            name='Output Gain'
            parameter={effect.outputGainParameter}
            isParameter={true}
            step={0.01}
            max={2}
            min={0}
          />
        </div>
    );
}

const mapStateToProps = (state, props) => {
  return {
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(TransientShaperComponent);
